var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('ui-icon',{staticClass:"cart-badge__icon",attrs:{"glyph":"bag"}}),(_vm.nCartItem > 0)?_c('data-badge',{staticClass:"cart-badge__badge",attrs:{"value":_vm.nCartItem}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }